<template>
  <div>
    <div>
      <el-form :disabled="!isOk" :inline="true" ref="form2">
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
          <el-button type="primary" @click="handleExport">导出</el-button>
          <el-button type="primary" @click="goHome">回首页</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div align="center">
      <el-table :data="tableData" ref="dataTable" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="name" label="名称" width="180" />
        <el-table-column prop="remark" label="备注" width="280" show-overflow-tooltip/>
        <el-table-column label="操作" width="240" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="handlePrivilege(scope.row)" size="small">权限</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleSet(scope.row)" size="small">修改</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleDel(scope.row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
        <el-form ref="form" :model="form" label-width="120px">
          <el-row>
            <el-col :span="20">
              <el-form-item label="名称" prop="name" :rules="[{required: true, message: '名称为空'}]">
                <el-input v-model="form.name" maxlength="50" style="width: 280px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" maxlength="200" style="width: 280px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel('form')">取消</el-button>
          <el-button type="primary" v-if="dialogStatus==='add'" @click="add('form')"><span>确定</span></el-button>
          <el-button type="primary" v-if="dialogStatus==='set'" @click="set('form')"><span>确定</span></el-button>
        </div>
      </el-dialog>
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible2" :close-on-click-modal="false" width="400px">
        <div align="center">
          <el-tree :data="privilegeData" ref="tree1" :props="defaultProps" show-checkbox style="width: 300px">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>
                <i :class="data.icon"></i>{{ data.name }}
              </span>
            </span>
          </el-tree>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel2('form')">取消</el-button>
          <el-button type="primary" @click="add2('form')"><span>确定</span></el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as http from '../api/http'
import * as util from '../util/util'
import global from '../components/Global'

export default {
  name: 'ZtRole',
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      dialogStatus: '',
      dialogTitle: '',
      dialogVisible: false,
      dialogVisible2: false,
      isOk: false,
      param: {},
      tableData: [],
      privilegeData: [],
      form: {}
    }
  },
  created () {
    let uid = global.uid
    let token = global.token
    // let uid = this.$cookies.get('uid0')
    // let token = this.$cookies.get('token0')
    if (uid === null || uid <= 0 || token === null || token === '') {
      this.$router.push('/')
      return
    }
    this.list()
  },
  methods: {
    goHome () {
      this.$router.push('/')
    },
    cancel2 () {
      this.dialogVisible2 = false
    },
    add2 (formName) {
      let arr = this.$refs.tree1.getCheckedNodes()
      // console.log(arr)
      this.form2.ids = ''
      for (let i = 0; i < arr.length; i++) {
        if (i > 0) {
          this.form2.ids += ','
        }
        this.form2.ids += arr[i].id
      }
      // console.log(this.form2)
      this.form2.uid = global.uid // this.$cookies.get('uid0')
      this.form2.token = global.token // this.$cookies.get('token0')
      http.post(global.url0 + 'zt_role_privilege/add/', this.form2).then(
        res => {
          if (res === 200) {
            this.dialogVisible2 = false
            this.$message.success('设置成功')
            // this.list()
          } else {
            this.$message.error('设置失败:' + res)
          }
        }
      ).catch(
        msg => {
          this.$message.error('设置异常:' + msg)
        }
      )
    },
    cancel () {
      this.dialogVisible = false
    },
    add (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.uid = global.uid // this.$cookies.get('uid0')
        this.form.token = global.token // this.$cookies.get('token0')
        // console.log(this.form)
        http.post(global.url0 + 'zt_role/add/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('新增成功')
              this.list()
            } else {
              this.$message.error('新增失败:' + res)
            }
          }
        )
      })
    },
    set (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.uid = global.uid // this.$cookies.get('uid0')
        this.form.token = global.token // this.$cookies.get('token0')
        http.post(global.url0 + 'zt_role/set/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('修改成功')
              this.list()
            } else {
              this.$message.error('修改失败:' + res)
            }
          }
        )
      })
    },
    handleAdd () {
      this.form = {}
      this.dialogStatus = 'add'
      this.dialogTitle = '新增'
      this.dialogVisible = true
    },
    handlePrivilege (row) {
      // this.form2 = JSON.parse(JSON.stringify(row))
      this.form2 = {}
      this.form2.key = this.param.key
      this.form2.role = row.id
      this.dialogStatus = 'set2'
      this.dialogTitle = '【' + row.name + '】 权限设置'
      this.dialogVisible2 = true
    },
    handleSet (row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogStatus = 'set'
      this.dialogTitle = '修改'
      this.dialogVisible = true
    },
    handleDel (row) {
      this.$confirm('此操作将永久删除记录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form = {}
        this.form.uid = global.uid // this.$cookies.get('uid0')
        this.form.token = global.token // this.$cookies.get('token0')
        this.form.id = row.id
        http.post(global.url0 + 'zt_role/del/', this.form).then(
          res => {
            if (res === 200) {
              this.$message.success('删除成功')
              this.list()
            } else {
              this.$message.error('删除失败')
            }
          }
        )
      })
    },
    listPrivilege () {
      this.privilegeData = []
      this.param.uid = global.uid // this.$cookies.get('uid0')
      this.param.token = global.token // this.$cookies.get('token0')
      http.post(global.url0 + 'zt_privilege/get/', this.param).then(
        res => {
          let list = res
          for (let i = 0; i < list.length; i++) {
            if (list[i].name.indexOf('管理') > -1) {
              list[i].icon = 'el-icon-star-on'
            } else {
              list[i].icon = 'el-icon-star-off'
            }
          }
          this.privilegeData = list
        }
      )
    },
    list () {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.tableData = []
          this.param.uid = global.uid // this.$cookies.get('uid0')
          this.param.token = global.token // this.$cookies.get('token0')
          http.post(global.url0 + 'zt_role/get/', this.param).then(
            res => {
              let resStr = res.toString
              if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
                this.$message.error(res)
                return
              }
              // console.log(res)
              this.tableData = res
              this.listPrivilege()
              this.isOk = true
            }
          )
        }
      })
    },
    handleExport () {
      util.toExcel(this.$refs.dataTable.columns, this.tableData, 'ZtRole')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/ZtRole.vue